import { makeQueryString } from '@/utils'
import { api } from './api'
import { Company } from '@/types/company'
import { Location } from '@/types/location'

export interface CompaniesListCompany {
  accountManagerId: string | null
  addressId: number
  bannerUrl: string | null
  businessType: string
  companyId: string
  companyWonAt: string // ISO date string
  createdAt: string // ISO date string
  createdBy: string
  customerStatus: string
  damageCountLi: number | null
  foundedDate: string // ISO date string
  isHeadquarters: boolean
  isTest: boolean
  lastDamageDateLi: string | null
  lastDamageValueLi: number | null
  locations: Location[]
  logoUrl: string | null
  lookingFor: string[]
  name: string
  partnerSource: string
  poaSigned: boolean
  updatedAt: string // ISO date string
}

export type CompaniesListResponse = CompaniesListCompany[]

export const getCompanies = (): Promise<CompaniesListResponse> =>
  api.get('/company')

interface CreateCompanyPayload {
  company: Record<string, any>
  location: Record<string, any>
}

export const createCompany = ({ company, location }: CreateCompanyPayload) =>
  api.post('/company', { company, location })

export const updateCompany = (id: string, { name }: { name: string }) =>
  api.put(`/company/${id}`, { name })

interface CreateCompanyUserPayload {
  name: string
  surname: string
  email: string
  phone: string
  isMd: boolean
}

export const createCompanyUser = (
  id: string,
  { name, surname, email, phone, isMd }: CreateCompanyUserPayload,
) => api.post(`/company/add-user/${id}`, { name, surname, email, phone, isMd })

export const getCompanyById = (id: string): Promise<Company> =>
  api.get(`/company/${id}`)

export const deleteCompany = (id: string) => api.delete(`/company/${id}`)

interface SignPoaPayload {
  companyId: string
  signature: string
  birthdate: string
}

export const signPoa = ({ companyId, signature, birthdate }: SignPoaPayload) =>
  api.post(`/home/poa-signature/${companyId}`, { signature, birthdate })

export interface KPIs {
  companies: {
    companyId: string
    name: string
    grossPrice: number
  }[]
  other: {
    grossPrice: number
  }
  totalGrossPrice: number
}

export interface ContractsOverviewResponse {
  companies: {
    companyId: string
    name: string
    grossPrice: number
    locations: {
      locationId: string
      name: string
      grossPrice: number
    }[]
  }[]
  other: {
    grossPrice: number
  }
  kpis: KPIs
}

export const getContractsOverview = (
  archivedView = false,
): Promise<ContractsOverviewResponse> =>
  api.get(
    `/company/insurances${makeQueryString({
      archivedView,
    })}`,
  )
